import {
  CorrectionBlockContentBlock,
  DatavizBlockContentBlock,
  EmailSubscribeBlock,
  FullWidthImageContentBlock,
  ImageWithFloatedTextContentBlock,
  PlainContentBlockContentBlock,
  PostContentBlock,
  PullQuoteContentBlock,
  RelatedStoryContentBlock,
  TabbedChartContentBlock,
  TagSubscribeBlock,
  YoutubeEmbedBlock,
} from "~/types/asgard/PostContentBlock";

const isContentBlockWithFieldName = (
  contentBlock: PostContentBlock,
  fieldName: string
): boolean =>
  typeof contentBlock === "object" &&
  "acf_fc_layout" in contentBlock &&
  contentBlock.acf_fc_layout === fieldName;

export const isCorrectionBlockContentBlock = (
  contentBlock: PostContentBlock
): contentBlock is CorrectionBlockContentBlock =>
  isContentBlockWithFieldName(contentBlock, "correction_block");

export const isDatavizBlockContentBlock = (
  contentBlock: PostContentBlock
): contentBlock is DatavizBlockContentBlock =>
  isContentBlockWithFieldName(contentBlock, "dataviz_block");

export const isTabbedChartsContentBlock = (
  contentBlock: PostContentBlock
): contentBlock is TabbedChartContentBlock =>
  isContentBlockWithFieldName(contentBlock, "tabbed_charts");

export const isFullWidthImageContentBlock = (
  contentBlock: PostContentBlock
): contentBlock is FullWidthImageContentBlock =>
  isContentBlockWithFieldName(contentBlock, "fullwidth_image");

export const isImageWithFloatedTextContentBlock = (
  contentBlock: PostContentBlock
): contentBlock is ImageWithFloatedTextContentBlock =>
  isContentBlockWithFieldName(contentBlock, "floated_image_text");

export const isPlainContentBlockContentBlock = (
  contentBlock: PostContentBlock
): contentBlock is PlainContentBlockContentBlock =>
  isContentBlockWithFieldName(contentBlock, "plain_content_block");

export const isPullQuoteContentBlock = (
  contentBlock: PostContentBlock
): contentBlock is PullQuoteContentBlock =>
  isContentBlockWithFieldName(contentBlock, "pull_quote");

export const isRelatedStoryContentBlock = (
  contentBlock: PostContentBlock
): contentBlock is RelatedStoryContentBlock =>
  isContentBlockWithFieldName(contentBlock, "related_story");

export const isEmailSubscribeBlock = (
  contentBlock: PostContentBlock
): contentBlock is EmailSubscribeBlock =>
  isContentBlockWithFieldName(contentBlock, "email_subscribe");

export const isTagSubscriptionBlock = (
  contentBlock: PostContentBlock
): contentBlock is TagSubscribeBlock =>
  isContentBlockWithFieldName(contentBlock, "tag_subscribe");

export const isYoutubeEmbedBlock = (
  contentBlock: PostContentBlock
): contentBlock is YoutubeEmbedBlock =>
  isContentBlockWithFieldName(contentBlock, "youtube_video");
